import { defineElement, html, i18n } from '@webtides/element-js';
import SpecFilter from '../spec-filter/SpecFilter';
import InputEvents from '../../../../legacy-library/webcomponents/_form/events/InputEvents';
import '../../../../legacy-library/webcomponents/_form/input-range/input-range';
import '../../../../legacy-library/webcomponents/_form/checkbox-control/checkbox-control';
import CurrencyFormatter from '../../../../js/helper/currency-formatter';
import SpecFilterEvents from '../spec-filter/SpecFilterEvents';

import styles from './spec-price-filter.css';

class SpecPriceFilter extends SpecFilter {
    connected() {
        super.connected();
        this.$refs.price.valueNumberFormatter = value => CurrencyFormatter.formattedRoundedPrice(value);
    }

    styles() {
        return [styles];
    }

    events() {
        return Object.assign(super.events(), {
            '[ref=price]': {
                [InputEvents.INPUT_RANGE_CHANGE]: ({ detail: { min, max } }) => {
                    const minValue = this.values.find(row => row.key === 'minValue');
                    minValue.selected = parseInt(min) !== parseInt(this.minRange);
                    minValue.value = parseInt(min);
                    const maxValue = this.values.find(row => row.key === 'maxValue');
                    maxValue.selected = parseInt(max) !== parseInt(this.maxRange);
                    maxValue.value = parseInt(max);

                    this.dispatch(SpecFilterEvents.FILTER_CHANGE, { [this.key]: this.values }, true);
                },
            },
            '[ref=sale]': {
                [InputEvents.INPUT_CHANGE]: () => {
                    this.sale = this.$refs.sale.checked;
                },
            },
        });
    }

    get minRange() {
        return this.meta.minRange;
    }

    get maxRange() {
        return this.meta.maxRange;
    }

    get minValue() {
        const minValue = this.values.find(row => row.key === 'minValue');
        if (!minValue.selected) {
            minValue.value = this.minRange;
        }
        return minValue.value;
    }

    get maxValue() {
        const maxValue = this.values.find(row => row.key === 'maxValue');
        if (!maxValue.selected) {
            maxValue.value = this.maxRange;
        }
        return maxValue.value;
    }

    get sale() {
        return this.values.find(row => row.key === 'sale')?.selected;
    }

    get unit() {
        return this.meta && this.meta.unit ? this.meta.unit : '€';
    }

    set minRange(value) {
        const index = this.values.findIndex(row => row.key === 'minRange');
        this.values[index].value = value;
    }

    set maxRange(value) {
        const index = this.values.findIndex(row => row.key === 'maxRange');
        this.values[index].value = value;
    }

    set minValue(value) {
        const index = this.values.findIndex(row => row.key === 'minValue');
        this.values[index].value = value;
    }

    set maxValue(value) {
        const index = this.values.findIndex(row => row.key === 'maxValue');
        this.values[index].value = value;
    }

    set sale(value) {
        const index = this.values.findIndex(row => row.key === 'sale');
        this.values[index].selected = value;
    }

    renderValues() {
        return html`
            <input-range
                class="mb-8"
                ref="price"
                min="${this.minRange}"
                max="${this.maxRange}"
                min-value="${this.minValue}"
                max-value="${this.maxValue}"
                unit="${this.unit}"
            >
            </input-range>
            ${this.sale
                ? html`
                      <checkbox-control
                          ref="sale"
                          class="font-normal text-base"
                          checked="${this.sale}"
                          label="${i18n('specPriceFilter.checkbox.displaySale')}
                      ></checkbox-control>
                  `
                : ''}
        `;
    }
}

defineElement('spec-price-filter', SpecPriceFilter);
